import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { PlaceToStayComponentAdd, PlaceToStayComponentGrabber } from './PlaceToStayComponentSidebar';
import { PlaceToStayComponentEdit } from './PlaceToStayComponentEdit';
import { PlaceToStayComponentGuest } from './PlaceToStayComponentGuest';

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const PlaceToStayComponentConfig: CustomJsonComponentConfig = {
  // Tip:
  // Replace this with the URL for the JSONSchema your component data uses.
  // This makes sure PageComponents with this schema will render your components.
  schemaUrl: 'https://withjoy.com/assets/public/schemas/placeToStayComponentSchemaV1_0_3.json',
  componentType: 'PlaceToStayComponent',
  adminSidebarComponent: {
    addComponentView: PlaceToStayComponentAdd,
    dragComponentView: PlaceToStayComponentGrabber,
    editComponentView: PlaceToStayComponentEdit,
    createComponentView: PlaceToStayComponentEdit,
  },
  guestSiteComponent: PlaceToStayComponentGuest,
} as const;
